var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL07 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 256.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2279.00, 0.00)",
    id: "L7_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2522.25,231.96 C2520.24,238.08 2513.61,253.50 2509.90,260.71 C2506.17,267.92 2497.38,282.38 2492.47,289.62 C2486.87,297.63 2461.99,329.93 2452.84,341.13 C2448.55,346.16 2438.87,357.40 2430.71,365.30 C2423.46,372.29 2410.43,382.35 2405.72,384.40 C2402.87,385.61 2396.91,386.81 2393.82,386.79 C2390.72,386.74 2383.82,385.33 2380.93,384.15 C2376.74,382.41 2365.17,374.18 2359.54,368.94 C2353.89,363.64 2342.15,350.13 2336.55,343.35 C2331.22,336.66 2321.38,323.57 2316.87,317.16 C2314.39,313.56 2303.96,295.18 2301.25,289.82 C2297.62,282.37 2292.47,270.09 2290.45,263.13 C2288.32,255.74 2284.92,237.49 2284.08,229.00 C2283.79,225.91 2283.08,206.65 2283.04,198.62 C2283.25,181.96 2286.01,142.25 2287.47,130.04 C2288.47,122.91 2291.17,107.52 2291.99,104.48 C2293.50,98.99 2297.08,89.76 2299.03,86.29 C2300.99,82.87 2305.06,78.43 2307.65,76.88 C2312.68,73.94 2328.85,69.38 2336.56,68.52 C2349.55,67.20 2377.58,66.33 2400.47,66.38 C2408.52,66.48 2430.23,66.86 2431.33,66.92 C2434.94,67.16 2459.15,69.92 2466.99,71.08 C2475.26,72.46 2486.50,74.99 2492.87,76.91 C2495.81,77.80 2502.35,81.10 2505.06,82.87 C2507.73,84.65 2512.67,88.98 2514.31,91.25 C2518.27,96.88 2523.19,112.80 2524.79,121.67 C2525.78,127.79 2527.61,141.72 2528.49,149.04 C2529.29,157.31 2530.84,174.62 2530.65,183.14 C2530.44,191.95 2528.11,209.66 2525.99,218.57 C2524.94,222.94 2522.81,230.25 2522.25,231.96 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL07, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-07.ab15c0fe.svg";
export { ForwardRef as ReactComponent };